var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Languages'),_c('Rain'),_c('header',{staticClass:"header"},[_c('Logo'),_c('Header')],1),_c('main',{staticClass:"main content"},[_c('Squiz'),_c('Reviews')],1),_c('footer',{staticStyle:{"height":"40px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }